export enum NotificationPriority {
  UNSET_PRIORITY = 'UNSET_PRIORITY', // Do not use, needed because of proto3 limitations
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
}
